// Başvuru listesindeki "Ek Bilgi" hücresinin ikon seti.
//
// Sıra ÖNEMLİ (kullanıcı kararı): "okundu" ikonu HER BAŞVURUDA göründüğü için
// en başta ve hep aynı hizada durur; resim/belge/konum ikonları ona göre
// kayabilir. Ayrı bir bileşene alındı ki sıra testle kilitlenebilsin.

import React from "react";
import { PhotoIcon, DocumentTextIcon, MapPinIcon } from "@heroicons/react/24/outline";

import ReadsCell from "./ReadsCell";

const hasImage = (app) => Boolean(app?.image1 || app?.image2 || app?.has_images);
const hasDocument = (app) =>
  Boolean(app?.document1 || app?.document2 || app?.has_documents);
const hasLocation = (app) => Boolean(app?.latitude && app?.longitude);

export default function ExtraInfoIcons({ app }) {
  return (
    <span className="cell-icons-set">
      {/* 1) Okundu — sabit ilk sıra (izinsizde bileşen hiçbir şey çizmez) */}
      <ReadsCell reads={app?.reads} />
      {hasImage(app) && <PhotoIcon title="Resim var" />}
      {hasDocument(app) && <DocumentTextIcon title="Belge var" />}
      {hasLocation(app) && <MapPinIcon title="Konum var" />}
    </span>
  );
}
